/* eslint-disable consistent-return */
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

const isValid = (val) => {
  const regexp = /^\d{0,2}?:?\d{0,2}$/;
  const [hoursStr, minutesStr] = val.split(':');

  if (!regexp.test(val)) {
    return false;
  }

  const hours = Number(hoursStr);
  const minutes = Number(minutesStr);

  const isValidHour = (hour) => Number.isInteger(hour) && hour >= 0 && hour < 13;
  const isValidMinutes = (minutesVal) => (Number.isInteger(minutesVal) && hours >= 0 && hours < 13) || Number.isNaN(minutesVal);
  if (!isValidHour(hours) || !isValidMinutes(minutes)) {
    return false;
  }

  if (minutes < 10 && Number(minutesStr[0]) > 5) {
    return false;
  }

  const valArr = val.indexOf(':') !== -1
    ? val.split(':')
    : [val];

  // check mm and HH
  if (valArr[0] && valArr[0].length && (parseInt(valArr[0], 10) < 0 || parseInt(valArr[0], 10) > 13)) {
    return false;
  }

  return !(valArr[1] && valArr[1].length && (parseInt(valArr[1], 10) < 0 || parseInt(valArr[1], 10) > 59));
};

const TimeInputComponent = ({
  initTime, disabled, mountFocus, onTimeChange, type, onFocusHandler, placeholder, className, name, onBlurHandler
}) => {
  const [time, setTime] = useState(initTime || '');
  const inputRef = useRef(null);

  useEffect(() => {
    if (!disabled && mountFocus) {
      setTimeout(() => {
        inputRef.current.focus();
      }, 0);
    }
  });

  let lastVal = '';

  const onChangeHandler = (val) => {
    // eslint-disable-next-line eqeqeq
    if (val == time) {
      return;
    }

    if (val.length === 2 && time.length !== 3) {
      val = `${val[0]}:${val[1]}`;
    }

    if (val.length === 5) {
      const temp = val.replace(':', '');
      val = `${temp.slice(0, 2) === '00' ? '12' : temp.slice(0, 2)}:${temp.slice(2, 4)}`;
    }

    if (isValid(val)) {
      if (val.length === 2 && lastVal.length !== 3 && val.indexOf(':') === -1) {
        val += ':';
      }

      if (val.length === 2 && lastVal.length === 3) {
        val = val.slice(0, 1);
      }

      if (val.length > 5) {
        return false;
      }

      lastVal = val;

      setTime(val);

      if (val.length === 4 && val.indexOf(':') === 1) {
        val = `0${val}`;
      }

      if (val.length === 5) {
        onTimeChange(val);
      }
    }
  };

  const getType = () => {
    if (type) {
      return type;
    }
    return 'tel';
  };

  return (
    <input
      name={name || undefined}
      className={className}
      type={getType()}
      disabled={disabled}
      placeholder={placeholder}
      value={time}
      onChange={(e) => onChangeHandler(e.target.value)}
      onFocus={(onFocusHandler) ? (e) => onFocusHandler(e) : undefined}
      onBlur={(onBlurHandler) ? (e) => onBlurHandler(e) : undefined}
      ref={inputRef}
    />
  );
};

TimeInputComponent.propTypes = {
  initTime: PropTypes.string,
  disabled: PropTypes.bool,
  mountFocus: PropTypes.bool,
  onTimeChange: PropTypes.func,
  type: PropTypes.string,
  onFocusHandler: PropTypes.func,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  name: PropTypes.string,
  onBlurHandler: PropTypes.func,
};

export default TimeInputComponent;
